import React from 'react';

import classes from '../installPics.css';

import Img from '../../../../../../../assets/01_solar_canopy-3_1.jpg';

const Image
 = () => (
     <div className={classes.installImages}>
         <img alt="Carport Diagram" src={Img} className={classes.installImg} />
     </div>
 );


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Carport/CarportImg2.js